import { useODataReadInfiniteApi, } from '../odata';
import { merge } from '@fluentui/react';
import { FIVE_MINUTES_IN_MSEC } from '../../constants/time';
import { endpoint } from './endpoint';
/**
 * Odata API for accessing an ininite list of pages of Notifications messages
 * (the served dataset constantly gets bigger).
 */
export const useNotificationInfiniteApi = (query, options) => useODataReadInfiniteApi(endpoint, query, merge({
    isAuthRequired: true,
    isVerificationRequired: true,
    uniqueIdentifier: 'id',
    useQueryOptions: {
        refetchInterval: FIVE_MINUTES_IN_MSEC,
    },
}, options));
